export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11404.bcf2cd19.jpg";